import { forwardRef } from 'react';

export type HeaderActionsSpacing = 'tight' | 'normal' | 'loose';

export interface HeaderActionsProps extends React.HTMLAttributes<HTMLDivElement> {
  spacing?: HeaderActionsSpacing;
  children: React.ReactNode;
}

const HeaderActions = forwardRef<HTMLDivElement, HeaderActionsProps>(({
  spacing = 'normal',
  children,
  className = '',
  ...props
}, ref) => {
  const getActionsClasses = () => {
    const baseClasses = ['flex', 'items-center'];

    // Spacing classes
    const spacingClasses = {
      tight: ['space-x-2'],
      normal: ['space-x-4'],
      loose: ['space-x-6']
    };

    return [
      ...baseClasses,
      ...spacingClasses[spacing],
      className
    ].filter(Boolean).join(' ');
  };

  return (
    <div
      ref={ref}
      className={getActionsClasses()}
      {...props}
    >
      {children}
    </div>
  );
});

HeaderActions.displayName = 'HeaderActions';

export default HeaderActions;